import {app,db} from './app';
import { getFirestore, collection, getDocs, query, where, collectionGroup } from 'firebase/firestore';

const getTeamUserSnaps = async (user) => {
    const currentUser = await getUserData(user);
    if (currentUser.id == null) return [];
    const usersRef = collectionGroup(db, 'users');
    const usersSnap = await getDocs(query(usersRef, where('id', '==', currentUser.id)));
    return usersSnap.docs.filter(doc => doc.ref.path.indexOf('teams') != -1);
};

export const getTeamIds = async (user) => {
    const snaps = await getTeamUserSnaps(user);
    return snaps.map(doc => doc.ref.path.split('/')[1]);
};

export const getTeamUserRefs = async (user) => {
    const snaps = await getTeamUserSnaps(user);
    return snaps.map(doc => doc.ref);
};

export const getUserData = async (user) => {
    const snap = await getSnap(user);
    return snap?.data() ?? { name: user.email, email: user.email };
};

export const getUserRef = async (user) => {
    const snap = await getSnap(user);
    return snap?.ref;
}

const getSnap = async (user) => {
    // Set to account user with same email
    const usersQuery = query(collection(db, 'users'), where('email', '==', user.email));
    const usersSnap = await getDocs(usersQuery);
    return usersSnap.docs[0];
};